const submitFullPageRequest = function ($link) {
  const authenticity_token = $('meta[name=csrf-token]').attr('content');
  const $form = $('<form>', { method: 'POST', action: $link.attr('href') });
  $form.append($('<input>', { type: 'hidden', name: '_method', value: $link.attr('data-method').toUpperCase() }));
  $form.append($('<input>', { type: 'hidden', name: 'authenticity_token', value: authenticity_token }));
  $('body').append($form);
  $form.submit();
};

const bindSweetAlert = function (e) {
  if ($(this).attr('data-swal-confirm') === 'false') return;

  window.stopEvent(e);

  const $link = $(this);
  window.swalConfirm
    .fire({
      icon: $link.attr('data-swal-icon') || 'warning',
      title: $link.attr('data-swal-title') || 'Are you sure?',
      text: $link.attr('data-swal-text'),
      showCancelButton: $link.attr('data-swal-show-cancel-button') != 'false',
      cancelButtonText: $link.attr('data-swal-cancel-button-text') || 'No',
      confirmButtonText: $link.attr('data-swal-confirm-button-text') || 'Yes',
    })
    .then((result) => {
      if (!result.isConfirmed) return;

      $('body').off('click', '[data-swal-confirm]', bindSweetAlert);
      if ($link.attr('data-swal-show-loader')) {
        $('.generic-loader').removeClass('d-none');
      }
      if ($link.attr('data-method')) {
        if ($link.attr('data-swal-full-page')) {
          submitFullPageRequest($link);
          return;
        }

        const authenticity_token = $('meta[name=csrf-token]').attr('content');
        $.ajax({
          method: $link.attr('data-method'),
          url: $link.attr('href'),
          data: { authenticity_token },
        });
      } else {
        $link[0].click();
      }
    });
};

$(document).on('turbolinks:load', function () {
  $('body').on('click', '[data-swal-confirm]', bindSweetAlert);
});
